// src/apiPublic.js
import axios from "axios";

function resolveApiBase() {
  const isNativeApp = typeof window !== "undefined" &&
    typeof window.Capacitor?.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform();

  if (isNativeApp) {
    return "https://takofy.com/api";
  }

  const raw = String(process.env.REACT_APP_API_BASE || "").trim();

  if (!raw && typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }

  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    return raw.replace(/\/+$/, "");
  }

  if (raw.startsWith("/") && typeof window !== "undefined") {
    return `${window.location.origin}${raw}`.replace(/\/+$/, "");
  }

  return raw.replace(/\/+$/, "");
}

const apiPublic = axios.create({
  baseURL: resolveApiBase(),
  withCredentials: false, // 🔴 EN KRİTİK SATIR
  headers: {
    "Content-Type": "application/json",
  },
});

const RETRYABLE_STATUS_CODES = new Set([502, 503, 504]);

apiPublic.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    const status = error?.response?.status;
    const method = String(config?.method || "get").toLowerCase();

    if (!config || config.signal?.aborted) {
      throw error;
    }

    const shouldRetry =
      method === "get" &&
      !config.__publicRetry &&
      (!status || RETRYABLE_STATUS_CODES.has(status));

    if (!shouldRetry) {
      throw error;
    }

    config.__publicRetry = true;
    await new Promise((resolve) => setTimeout(resolve, 350));
    return apiPublic.request(config);
  }
);

export default apiPublic;
